module.exports = __webpack_public_path__ + "static/media/news-pro-broadcast.6f700337.png";